import { createSelector } from "reselect";
import { getFormValues } from "redux-form";
import { reduce } from "lodash";

import { WATCH_LIST_COLLECTION_FORM } from "../../constants/forms";

export const getSelectedItems = createSelector(
  getFormValues(WATCH_LIST_COLLECTION_FORM),
  (values = {}) =>
    reduce(values, (acc, value, key) => (value ? [...acc, key] : acc), [])
);
